import {
  CheckCircleTwoTone,
  DownOutlined,
  ShopOutlined,
  UsbOutlined,
} from '@ant-design/icons'
import './App.css'
import { Space } from 'antd'
import { Content } from 'antd/es/layout/layout'
import locales from './locales/locale'
import elettronica from './images/elettronica.png'
import cibo from './images/cibo.png'
import { memo } from 'react'
import { Fade, Slide } from 'react-awesome-reveal'
import { Link } from 'react-router-dom'

export const Home = ({ lang }: { lang: string }) => {
  return (
    <Content style={{ zIndex: 1 }}>
      <div className="background">
        <Space
          className="primoParagrafo"
          direction="vertical"
          align="start"
          size="small"
        >
          <h2>Zefiro</h2>
          <p>{locales.paragrafo1}</p>
          <DownOutlined className="arrow-down" />
        </Space>
      </div>
      <Fade>
        <div className="paragrafo">
          <div style={{ width: '90%' }}>
            <h1>{locales.paragrafo3.titolo}</h1>
            <p style={{ fontSize: '1.5vw' }}>
              {locales.paragrafo3.descrizione}
            </p>
          </div>
          <div
            className="pallini"
            style={{
              textAlign: 'center',
              width: '90%',
              display: 'flex',
            }}
          >
            <Link to="/analcolici">
              <div className="box-offer">
                <div style={{ placeContent: 'center', height: '8vw' }}>
                  <ShopOutlined />
                </div>
                <h1>{locales.paragrafo3Bis.riquadro2.titolo}</h1>
                <p>{locales.paragrafo3Bis.riquadro2.descrizione}</p>
              </div>
            </Link>
            <Link to="/elettronica">
              <div className="box-offer">
                <div style={{ placeContent: 'center', height: '8vw' }}>
                  <UsbOutlined style={{ fontSize: '3vw' }} />
                </div>
                <h1>{locales.paragrafo3Bis.riquadro3.titolo}</h1>
                <p>{locales.paragrafo3Bis.riquadro3.descrizione}</p>
              </div>
            </Link>
          </div>
          {/* <img alt="By Karolina Grabowska" src={team} /> */}
        </div>
      </Fade>
      <div
        style={{ textAlign: 'initial' }}
        className="paragrafo sfondoScuro reverse"
      >
        <div>
          <Fade>
            <h1>{locales.paragrafo5.titolo1}</h1>
            <p>{locales.paragrafo5.descrizione1}</p>
          </Fade>
          <br />
          <br />
          <Slide direction="right">
            <Space
              style={{
                alignItems: 'baseline',
              }}
            >
              <CheckCircleTwoTone twoToneColor={'#9b9b9b'} />
              <Space direction="vertical">
                <h3>{locales.paragrafo5.titolo2}</h3>
                <span>{locales.paragrafo5.descrizione2}</span>
              </Space>
            </Space>
          </Slide>
          <br />
          <br />
          <br />
          <Slide direction="right">
            <Space
              style={{
                alignItems: 'baseline',
              }}
            >
              <CheckCircleTwoTone twoToneColor={'#9b9b9b'} />
              <Space direction="vertical">
                <h3>{locales.paragrafo5.titolo3}</h3>
                <span>{locales.paragrafo5.descrizione3}</span>
              </Space>
            </Space>
          </Slide>
          <br />
          <br />
          <br />
          <Slide direction="right">
            <Space
              style={{
                alignItems: 'baseline',
              }}
            >
              <CheckCircleTwoTone twoToneColor={'#9b9b9b'} />
              <Space direction="vertical">
                <h3>{locales.paragrafo5.titolo4}</h3>
                <span>{locales.paragrafo5.descrizione4}</span>
              </Space>
            </Space>
          </Slide>
        </div>
        <Fade>
          <img
            className="img-style"
            alt="By Pixebay user"
            width={'100%'}
            src={cibo}
          />
        </Fade>
      </div>
      <div style={{ textAlign: 'initial' }} className="paragrafo">
        <div>
          <Fade>
            <h1>{locales.paragrafo6.titolo1}</h1>
            <p>{locales.paragrafo6.descrizione1}</p>
          </Fade>
          <br />
          <br />
          <Slide direction="left">
            <Space
              style={{
                alignItems: 'baseline',
              }}
            >
              <CheckCircleTwoTone />
              <Space direction="vertical">
                <h3>{locales.paragrafo6.titolo2}</h3>
                <span>{locales.paragrafo6.descrizione2}</span>
              </Space>
            </Space>
          </Slide>
          <br />
          <br />
          <br />
          <Slide direction="left">
            <Space
              style={{
                alignItems: 'baseline',
              }}
            >
              <CheckCircleTwoTone />
              <Space direction="vertical">
                <h3>{locales.paragrafo6.titolo3}</h3>
                <span>{locales.paragrafo6.descrizione3}</span>
              </Space>
            </Space>
          </Slide>
          <br />
          <br />
          <br />
          <Slide direction="left">
            <Space
              style={{
                alignItems: 'baseline',
              }}
            >
              <CheckCircleTwoTone />
              <Space direction="vertical">
                <h3>{locales.paragrafo6.titolo4}</h3>
                <span>{locales.paragrafo6.descrizione4}</span>
              </Space>
            </Space>
          </Slide>
        </div>
        <Fade>
          <img
            className="img-style"
            alt="By AI"
            width={'100%'}
            src={elettronica}
          />
        </Fade>
      </div>

      <div
        className="paragrafo sfondoScuro"
        style={{ minHeight: 'auto', margin: '10vw 0' }}
      >
        <div style={{ width: '80%', paddingBottom: 0 }}>
          <Fade>
            <h1>{locales.paragrafo7.titolo}</h1>
            <p>{locales.paragrafo7.descrizione}</p>
          </Fade>
        </div>
      </div>
    </Content>
  )
}

export default memo(Home)
